import jQuery from 'jquery';
const $ = jQuery;

window.jQuery = $;
window.$ = $;


import 'jquery.easing';


import Accordion from './Accordion';
import SpMenu from './SpMenu';

const copyToClipboard = (text) => {
  // テキストコピー用の一時要素を作成
  const pre = document.createElement('pre');

  // テキストを選択可能にしてテキストセット
  pre.style.webkitUserSelect = 'auto';
  pre.style.userSelect = 'auto';
  pre.textContent = text;

  // 要素を追加、選択してクリップボードにコピー
  document.body.appendChild(pre);
  document.getSelection().selectAllChildren(pre);
  const result = document.execCommand('copy');

  // 要素を削除
  document.body.removeChild(pre);

  return result;
}


class PageHome {
  constructor(mainApp) {
    this.$window          = $(window);
    this.mainApp = mainApp;
    this.scrollTop = 0;
    this.$hero = $('.Hero');
    this.imgMode = 'HORIZONTAL';



    $('.ScrollDown').css('opacity', 1);
    this.$hero.animate({'opacity': 1}, 1400, 'easeInOutSine', () => {
      $('.Header').addClass('on-complete-fadein');
      $('.HeaderMenuList').addClass('-fadein');
    });


    this.$window
      .on('resize', ()=>{
        this.onWindowResize();
      })
      .on('scroll', ()=>{
        this.onWindowScroll();

      });
    this.onWindowResize();
  }
  onWindowResize() {
    if(this.$hero.outerWidth() > this.$hero.height()) {
      this.imgMode = 'HORIZONTAL';
      this.$hero.removeClass('-vertical');
    } else {
      this.imgMode = 'VERTICAL';
      this.$hero.addClass('-vertical');
    }
  }
  onWindowScroll() {
    this.scrollTop = this.$window.scrollTop();
    if(this.scrollTop >= parseInt(this.$hero.height() * 0.55)) {
      $('body').addClass('on-complete-firstview');
    } else {
      $('body').removeClass('on-complete-firstview');
    }
  }
}

class MainApp {
  constructor() {
    this.$window          = $(window);
    this.pageApp = undefined;

    $(document).on('touchstart', 'a, button', (e) => {
      $(e.currentTarget).attr('data-touch', 'true');
    });

    $(document).on('mouseleave', 'a, button', (e) => {
      $(e.currentTarget).removeAttr('data-touch');
    });

    new SpMenu();

    /*
    if($('.Hero').length) {
      new Hero();
    }
    */

    $('.js-accordion').each((i, e) => {
      new Accordion($(e))
    });

    $('.js-hero-scrolldown').on('click', () => {
      this.scrollPage($('.Statement').offset()['top']);
    });


    this.scrollableElement = null;
    let firefox = navigator.userAgent.match(/Firefox\/([0-9]+)\./);
    if ('scrollingElement' in document) {
      this.scrollableElement = document.scrollingElement;
    } else if (/*@cc_on!@*/false || (!!window.MSInputMethodContext && !!document.documentMode)) {
      this.scrollableElement = document.documentElement;
    } else if (firefox && parseInt(firefox[1]) <= 47) {
      this.scrollableElement = document.documentElement;
    } else {
      this.scrollableElement = document.body;
    }

    if($('.Article').length) {
      $('.Article').find('p').each((i, e) => {
        if($(e).find('img').length) {
          $(e).addClass('ImgWrap');
        }
      });
      $('.Article').find('a').each((i, e) => {
        // console.log('href', $(e).attr('href'));
        if($(e).attr('href').indexOf('goodbaton.jp') == -1 || ($(e).attr('target') != undefined && $(e).attr('target') == '_blank')) {
          $(e).append('<svg aria-hidden="true" class="Icon Icon--blank"><use xlink:href="#icon--blank"/></svg>');
        }
      });
    }

    $('.js-copy-url').on('click', (e) => {
      console.log('copy', $(e.currentTarget).attr('href'));
      copyToClipboard($(e.currentTarget).attr('href'));
      $(e.currentTarget).find('.CopiedMessage').css('opacity', 1).delay(2000).animate({'opacity': 0}, 1000, 'easeOutExpo');

      e.preventDefault();
      return false;
    });



    // HistoryContent
    /*
    $('.HistoryContent').find('a').each((i, e) => {
      if($(e).attr('target') == '_blank') {
        $(e).append('<svg class="Icon Icon--blank" aria-hidden="true"><use xlink:href="#icon--blank"/></svg>');
      }
    });
    */

    if($('body').hasClass('page-template-page-company')) {
      $('.FlexibleContent').find('a').each((i, e) => {
        $(e).append('<svg aria-hidden="true" class="Icon Icon--jump"><use xlink:href="#icon--jump"/></svg>');
      });
    }

    if($('body').hasClass('page-template-page-home')) {
      new PageHome(this);
    }

    $('.FormRow').each((i, e) => {
      if($(e).find('input[type="radio"]').length) {
        $(e).addClass('-required');
      } else {
        if($(e).find('input').hasClass('wpcf7-validates-as-required')) {
          $(e).addClass('-required');
        }
        if($(e).find('textarea').hasClass('wpcf7-validates-as-required')) {
          $(e).addClass('-required');
        }
        if($(e).find('select').hasClass('wpcf7-validates-as-required')) {
          $(e).addClass('-required');
        }
      }

    });

    $('.FormRow__content--submit').find('input').after('<svg class="BtnPrimary__icon BtnPrimary__icon--send" aria-hidden="true"><use xlink:href="#icon--send"/></svg>')

    this.$window
      .on('resize', ()=>{
        this.onWindowResize();
      })
      .on('scroll', ()=>{
        this.onWindowScroll();

      });
    this.onWindowResize();
  }

  /*
  isTouchDevice() {
    return ('ontouchstart' in window || navigator.msPointerEnabled) ? true : false;
  }
  */

  scrollPage(val, isCancelTransition = false) {
    if(isCancelTransition) {
      $(this.scrollableElement).stop(false).scrollTop(val);
    } else {
      $(this.scrollableElement).stop(false).animate(
        {'scrollTop': val},
        1200,
        'easeInOutExpo'
      );
    }
  }

  onWindowResize() {
    this.windowWidth = this.$window.width();
    this.windowHeight = this.$window.height();

    if(this.pageApp != undefined) {
      this.pageApp.onWindowResize();
    }

    this.onWindowScroll();
  }

  onWindowScroll() {
    this.scrollTop = this.$window.scrollTop();
    if(this.pageApp != undefined) {
      this.pageApp.onWindowScroll(this.scrollTop);
    }
  }
}

$('document').ready(() => {
  new MainApp();
});


$(window).on('load', () => {
});
